import Flex from "../../../../Component/Elements/Flex/Flex";
import PhotoListItemCard from "../PhotoListItemCard/PhotoListItemCard";
import { photoDetailsTypeCodeType, photoTypeCodeType } from "../../static/interface/const.interface";
import CSS from "./static/css/PhotoList.module.css";
import EmptyData from "../../../../Component/Elements/EmptyData/EmptyData";
import LoopAnimationModal from "../../../../Component/Elements/LoopAnimationModal/LoopAnimationModal";
import useMyPhotoREST from "../../hooks/useMyPhotoREST.hook";
import useProductListREST from "../../../ProductManufacturing/hooks/REST/useProductListREST";
import { PRODUCT_LIST_FILTER_CODE_OBJ } from "../../../ProductManufacturing/static/ts/const";
import usePhotoListSetter from "../../hooks/usePhotoListSetter.hook";
import { PHOTO_DETAILS_TYPE_CODE, PHOTO_TYPE_CODE } from "../../static/ts/const";
import ProductBlock from "../../../ProductManufacturing/components/ProductBlock/ProductBlock";
import { useNavigate } from "react-router-dom";
import { getQueryParamsUrl } from "../../../../Common/ts/commonTools";
import { backPointUrlManagerClass } from "../../../../Common/ts/appTools";

const backPointUrlManager = new backPointUrlManagerClass();

const PhotoList = (
    {
        photo_type,
        photo_details_type,
    }:{
        photo_type: photoTypeCodeType;
        photo_details_type: photoDetailsTypeCodeType;
    }
) => {
    const navigate = useNavigate();

    const {
        myPhotoDataList,
        myPhotoDataListIsLoading,
        myPhotoDataListError,
        myPhotoDataListRefetch,
    } = useMyPhotoREST({
        main_type: photo_type
    })

    const {
        productListData,
        productListIsLoading,
        productListError,
        productListRefetch
    } = useProductListREST({
        search_type: PRODUCT_LIST_FILTER_CODE_OBJ.complete
    })

    const {
        photoListData
    } = usePhotoListSetter({
        myPhotoDataList,
        productListData,
        main_type: photo_type,
        photo_details_type: photo_details_type,
    })


    const moveToProductDetailHandler = (contract_product_id: number, album_save_id: number | null, photo_upload_id: number | null) => {
        const l_back_point = backPointUrlManager.encoded({url: `/photoList?tab1=2`});
        const m_detail_url: string = getQueryParamsUrl({
            main_url: "/productDetail",
            queryParams: {
                contract_product_id: `${contract_product_id}`,
                album_save_id: `${album_save_id || 0}`,
                photo_upload_id: `${photo_upload_id || 0}`,
                back_point: l_back_point
            }
        });

        navigate(m_detail_url);
    }


    const moveToPhotoDetailHandler = (
        {
            ...props
        }:{
            // photo_upload_id: number;
            schedule_id: number | null;
            photo_type_code: photoTypeCodeType;
            photo_details_type_code: photoDetailsTypeCodeType;
        }
    ) => {
        let m_tab1: string = "";
        if(photo_type === PHOTO_TYPE_CODE.contract_shoot){
            m_tab1 = "0";
        }else{
            m_tab1 = "1";
        }

        const l_back_point = backPointUrlManager.encoded({url: `/photoList?tab1=${m_tab1}`});
        const m_detail_url: string = getQueryParamsUrl({
            main_url: "/photoDetail",
            queryParams: {
                // photo_upload_id: `${props.photo_upload_id}`,
                photo_type: `${props.photo_type_code}`,
                viewRange_type: `${props.photo_details_type_code}`,
                schedule_id: `${props.schedule_id || 0}`,
                back_point: l_back_point,
            }
        });

        navigate(m_detail_url);
    }

    return(
        <div className={CSS.l_PhotoList_main}>
            {
                photoListData.length > 0
                ?   <Flex
                        option={"margin_bottom_zero"}
                        class_name_list={[CSS.l_PhotoList_cardList]}
                    >
                        {
                            photoListData.map((item, index) => {
                                if(photo_type === PHOTO_TYPE_CODE.contract_shoot && photo_details_type === PHOTO_DETAILS_TYPE_CODE.edit_end){
                                    return(
                                        <div
                                            key={index}
                                            className={CSS.l_PhotoList_cardItem}
                                        >
                                            <ProductBlock
                                                product_name={item.title}
                                                product_type={item.product_type}
                                                product_state={item.product_state}
                                                product_qty={item.product_qty}
                                                options={item.options}
                                                thumbnail_src={item.img_url?.small_url}
                                                onClick={moveToProductDetailHandler.bind(null, item.contract_product_id, item.album_save_id, item.photo_upload_id)}
                                            />
                                        </div>
                                    )
                                }else{
                                    return (
                                        <div
                                            key={index}
                                            className={CSS.l_PhotoList_cardItem}
                                        >
                                            <PhotoListItemCard
                                                img_url={item.img_url?.small_url}
                                                title={`${item.title} ${item.photo_type}`}
                                                info={`${item.info} ∙ ${item.office_name}`}
                                                upload_date={`${item.upload_date} (등록일)`}
                                                new_download_file_count={item.new_download_file_count}
                                                onClick={moveToPhotoDetailHandler.bind(null, {
                                                    // photo_upload_id: item.photo_upload_id,
                                                    schedule_id: item.schedule_id,
                                                    photo_type_code: photo_type,
                                                    photo_details_type_code: photo_details_type,
                                                })}
                                                joined_event={item.joined_event}
                                            />
                                        </div>
                                    )
                                }
                            })
                        }
                    </Flex>
                :   !myPhotoDataListIsLoading && !productListIsLoading
                    ?   <EmptyData />
                    :   null
            }

            <LoopAnimationModal
                isModalOpen={myPhotoDataListIsLoading}
            />
        </div>
    )
}

export default PhotoList;
